import { tokens } from 'styling/tokens'

export const STATUS_META: { name: string; color: string }[] = [
  { name: 'Completed', color: tokens.status.success.fg },
  { name: 'In Progress', color: tokens.status.info.fg },
  { name: 'Not Started', color: tokens.text.muted },
  { name: 'Idle', color: tokens.status.warning.fg },
  { name: 'Paused', color: tokens.accent.base },
  { name: 'Stopped', color: tokens.status.danger.fg },
]

export const toDonutRows = (data: { name: string; value: unknown }[] | undefined) =>
  STATUS_META.map((s) => ({
    label: s.name,
    value: Number(data?.find((d) => d.name === s.name)?.value) || 0,
    color: s.color,
  }))
